
import { useState } from 'react';
import './App.css';
import Navbar from './components/navbar/navbar';
import RoutesList from './RoutesList/Routes';

function App() {
  const [selectedEvent, setSelectedEvent] = useState(false);
  const [currentEvent, setcurrentEvent] = useState(null);
  return (
    <div className="App">
    <Navbar />
    <RoutesList selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} currentEvent={currentEvent} setcurrentEvent={setcurrentEvent} />
    </div>
  );
}

export default App;
